const CHARTING_COLOURS = [
  '#b7edde',
  '#65ccaf',
  '#acecf3',
  '#44c8d7',
  '#a6cdff',
  '#529bfa',
  '#d2befa',
  '#a88ae6',
  '#ffbdd6',
  '#ff5c9a',
  '#ffc2b3',
  '#ff643d',
  '#fcd49f',
  '#ffa126',
  '#ffecab',
  '#f7c72a',
  '#12a67c',
  '#0c7a5b',
  '#1ea4b3',
  '#1a818c',
  '#3881e1',
  '#3166ab',
  '#8660d1',
  '#6345a1',
  '#f31167',
  '#99003a',
  '#de4721',
  '#b53413',
  '#f38b00',
  '#c06c00',
  '#ebb400',
  '#bd9100',
  '#acf5be',
  '#5fe380',
  '#99e0ff',
  '#40b4e5',
  '#a6d2ff',
  '#40a0ff',
  '#c3c2ff',
  '#8483e6',
  '#ffbdbd',
  '#ff7e7e',
  '#ebd7cf',
  '#dcbbad',
  '#ebd6a9',
  '#cc9e3b',
  '#ffc7ab',
  '#ff671b',
  '#43c463',
  '#217a37',
  '#1894c9',
  '#005b82',
  '#0875e1',
  '#004387',
  '#5c59e6',
  '#2e2d91',
  '#ff4c4c',
  '#b82828',
  '#8c7266',
  '#664d42',
  '#b37f10',
  '#8c6000',
  '#e04b00',
  '#a33600',
  '#caf593',
  '#77bc1f',
  '#c3c2ff',
  '#7891ff',
  '#fac0ff',
  '#de8ae6',
  '#fcc9c5',
  '#ff867d',
  '#ffda61',
  '#e6bf6c',
  '#ff957a',
  '#de2e21',
  '#ffbc63',
  '#ff9b69',
  '#a7e05c',
  '#609915',
  '#5e77e6',
  '#4b5eb3',
  '#c860d1',
  '#97499e',
  '#ff5347',
  '#de2e21'
];

interface ChartingColorOffset {
  group: number;
  starting: number;
  offset: number;
}

const CHARTING_COLOR_OFFSETS = {
  bar: { group: 3, starting: 0, offset: 16 },
  pie: { group: 3, starting: 3, offset: 16 },
  line: { group: 4, starting: 6, offset: 16 },
  bubble: { group: 6, starting: 10, offset: 16 }
};

const formColorPalette = (list: string[], chartOptions: ChartingColorOffset) => {
  let colours: string[] = [];
  for (let i = chartOptions.starting; i < list.length; i += chartOptions.offset) {
    colours = colours.concat(list.slice(i, i + chartOptions.group));
  }
  const remaining = CHARTING_COLOURS.filter((c) => !colours.includes(c));
  return colours.concat(remaining);
};

const PIE_CHART_COLOR_PALETTE = formColorPalette(CHARTING_COLOURS, CHARTING_COLOR_OFFSETS.pie);

const LINE_CHART_COLOR_PALETTE = formColorPalette(CHARTING_COLOURS, CHARTING_COLOR_OFFSETS.line);

const BAR_COLUMN_COLOR_PALETTE = formColorPalette(CHARTING_COLOURS, CHARTING_COLOR_OFFSETS.bar);

const BUBBLE_COLOR_PALETTE = formColorPalette(CHARTING_COLOURS, CHARTING_COLOR_OFFSETS.bubble);

export const chartingTheme = {
  PIE_CHART_COLOR_PALETTE,
  LINE_CHART_COLOR_PALETTE,
  BAR_COLUMN_COLOR_PALETTE,
  BUBBLE_COLOR_PALETTE
};
